(function () {
  function inyectarEstilos() {
    if (document.getElementById('diferenciadores-estilos')) return;
    var css = [
      '@media (min-width: 990px){',
      '.product-diferenciadores .product-diferenciadores__grid{',
      'grid-template-columns:repeat(var(--difer-cols-desktop,3),1fr) !important;',
      'gap:28px 24px !important;}',
      '}'
    ].join('');
    var s = document.createElement('style');
    s.id = 'diferenciadores-estilos';
    s.appendChild(document.createTextNode(css));
    document.head.appendChild(s);
  }

  function init() {
    if (document.querySelector('[data-diferenciadores]')) {
      inyectarEstilos();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
